import {
  Component,
  ViewEncapsulation,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from '@angular/core';

import { SnBadgeConfig, SnBadge } from '@lib/ui/badge';
import { SnIcon } from '@lib/ui/icon';
import { COLORS } from '@lib/ui/theme';

import {
  GoogleMapIconMarkerIcon,
  GoogleMapMarkerIconLabel,
  GoogleMapMarkerStyleOptions,
} from '../../overlays';

@Component({
  selector: 'sn-google-map-marker-icon',
  templateUrl: './marker-icon.component.html',
  styleUrls: ['./marker-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class GoogleMapMarkerIconComponent {
  private _icon: SnIcon;
  private _badge: SnBadge;
  private _iconLabel: GoogleMapMarkerIconLabel = {
    text: null,
    top: 0,
    left: 0,
    color: COLORS['grey-0'],
  };

  private _iconStyle: GoogleMapMarkerStyleOptions = {
    rotation: 90,
  };

  constructor(private readonly _changeDetectorRef: ChangeDetectorRef) {}

  get iconLabel(): GoogleMapMarkerIconLabel {
    return this._iconLabel;
  }

  get iconStyle(): GoogleMapMarkerStyleOptions {
    return this._iconStyle;
  }

  get icon(): SnIcon {
    return this._icon;
  }

  get badge(): SnBadge {
    return this._badge;
  }

  public setIcon(config: GoogleMapIconMarkerIcon): void {
    this._icon = SnIcon.fromConfig(config);
    this._changeDetectorRef.detectChanges();
  }

  public setIconLabel(config: GoogleMapMarkerIconLabel): void {
    this._iconLabel = { ...this._iconLabel, ...config };
    this._changeDetectorRef.detectChanges();
  }

  public setBadge(config: SnBadgeConfig): void {
    this._badge = SnBadge.fromConfig(config);
    this._changeDetectorRef.detectChanges();
  }
}
